
$('body').find('table').each(function() {
  $(this).wrap('<div class="table-block"></div>');
});

$(document).ready(function () {

    function disable_scroll_mobile() {
        window.addEventListener('touchmove', wheel, { passive: false });
    }
    function enable_scroll_mobile() {
        window.removeEventListener('touchmove', wheel, { passive: false });
    }
    // var keys = [32, 33, 34, 35, 36, 37, 38, 39, 40];
    var keys = [33, 34, 35, 36, 38, 40];
    function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault)
            e.preventDefault();
        e.returnValue = false;
    }
    function keydown(e) {
        for (var i = keys.length; i--;) {
            if (e.keyCode === keys[i]) {
                preventDefault(e);
                return;
            }
        }
    }
    function wheel(e) {
        preventDefault(e);
    }
    function disable_scroll() {
        if (window.addEventListener) {
            window.addEventListener('DOMMouseScroll', wheel);
        }
        window.addEventListener('mousewheel', wheel, { passive: false });
        document.onkeydown = keydown;
        disable_scroll_mobile();
    }
    function enable_scroll() {
        if (window.removeEventListener) {
            window.removeEventListener('DOMMouseScroll', wheel);
        }
        window.removeEventListener('mousewheel', wheel, { passive: true });
        enable_scroll_mobile();
    }

    /*** iOS Body Scroll Lock with open menu/other modal blocks ***/

    var $docEl = $('body'),
        scrollTop;
    var overlayClose = function () {
        $.unlockBody();
    }
    var overlayOpen = function () {
        $.lockBody();
    }
    $.lockBody = function () {
        if (window.pageYOffset) {
            scrollTop = window.pageYOffset;
        }
        $docEl.css({
            height: "100%",
            overflow: "hidden"
        });
        $('html').css({
            height: "100%",
            overflow: "hidden"
        });
    }
    $.unlockBody = function () {
        $docEl.css({
            height: "",
            overflow: ""
        });
        $('html').css({
            height: "",
            overflow: ""
        });
        window.scrollTo(0, scrollTop);
        window.setTimeout(function () {
            scrollTop = null;
        }, 0);
    }

    /**
     * Open|Close popups
     */
    $('.wrap_container').on('click', '.open-popup', function (e) {
        e.preventDefault();
        if ($(this).hasClass('disabled')) return false;

        var $this = $(this);
        openPopups($this);
    });

    //Close this popup with button class
    $('.close_this_popup').on('click', function (e) {
        e.preventDefault();
        $(this).closest('.wrap_popup').find('.close').trigger('click');
    });

    function openPopups($this) {
        calcSetTopHeight($('#' + $this.attr('data-popup')));

        $('.overlay_page, #' + $this.attr('data-popup')).fadeIn(200);

        if (window.innerWidth < 1092) {
            overlayOpen();
        } else {
            disable_scroll();
        }

        //Set active to first input
        setTimeout(function () {
            $('#' + $this.attr('data-popup')).find('form:not(.rent-form) input:not([type="hidden"])').first().focus();
        }, 250);

    }

    function calcSetTopHeight($el) {
        var width = $el.outerWidth() / 2,
            height = $el.outerHeight() / 2,
            windowH = $(window).height() / 2,
            windowW = $(window).width() / 2,
            top = windowH - height,
            left = windowW - width;

        if($(window).width() > 767) {
            $el.css('top', top + 'px');
            $el.css({
                'top': top + 'px',
                'left': left + 'px',
            });
        }
    }

    $('.wrap_popup').each(function () {
        var $el = $(this);
        calcSetTopHeight($el);
    });

    $('.wrap_popup .close, .overlay_page').on('click', function (e) {
        e.preventDefault();

        if($('#beforeDeletingArticle').css('display') !== 'block') {
            $('.overlay_page, .wrap_popup').fadeOut(200, function () {
                $('.wrap_popup').find('form')[0].reset();
            });
        }

        if (window.innerWidth < 1092) {
            overlayClose();
        } else {
            enable_scroll();
        }
    });


    /**
     * Phone mask
     */
    // $('.phone_inputmask').inputmask({
    //     "oncomplete": function () {
    //         $(this).addClass('completed');
    //     },
    //     "onincomplete": function () {
    //         $(this).removeClass('completed');
    //     },
    //     alias: "phone",
    //     "clearIncomplete": true
    // });

    var maskList = $.masksSort($.masksLoad("/js/inputmask-multi/phone-codes.json"), ['#'], /[0-9]|#/, "mask");
    var maskOpts = {
        inputmask: {
            definitions: {
            '#': {
                validator: "[0-9]",
                cardinality: 1
            }
            },
            showMaskOnHover: false,
            autoUnmask: true,
        },
        match: /[0-9]/,
        replace: '#',
        list: maskList,
        listKey: "mask",
        onMaskChange: function(maskObj, completed) {
            $(this).attr("data-mask", maskObj.mask);
            $(this).attr("data-mask-len", maskObj.mask.length);
        },
    };

    $('.phone_inputmask').each(function() {
        var elem = $(this);
        elem.inputmasks(maskOpts);
    });

    $('.phone_inputmask').blur(function() {
        var elem = $(this);

        if ( elem.val() != '' ) {
            var complete = elem.inputmasks('isCompleted');
        }
    });

    $('.phone_inputmask').on('mousedown', function() {
        var elem = $(this);
        if($(this).val().length == 0) {
            // elem.val('+380');
            // for cursor is at the end
            var that = this;
            setTimeout(function(){ that.selectionStart = that.selectionEnd = 10000; }, 0);
        }
    });

    /**
     * Form validate
     */
    $.validator.methods.email = function (value, element) {
        return this.optional(element) || /^([а-яА-Яa-zA-Z0-9_.+-])+\@(([а-яА-Яa-zA-Z0-9-])+\.)+([а-яА-Яa-zA-Z0-9]{2,4})+$/.test(punycode.toUnicode(value));
    };
    $.validator.methods.tel = function (value, element) {
        let mask = $(element).data('mask');
        return this.optional(element) || mask.match(/[0-9#]/g).length == value.toString().length;
    };

    $('form.validate').each(function () {
        $(this).validate({
            highlight: function (element) {
                $(element).addClass("error").removeClass("success");
            },
            unhighlight: function (element) {
                $(element).removeClass("error").addClass("success");
            },
            //Send form
            submitHandler: function (form) {
                console.log('Form send');
                // $(form).closest('.wrap_popup').find('.close').trigger('click');
            }
        });
    });


    /**
     * Owl carousel
     */
    $('.carousel').owlCarousel({
        loop: false,
        items: 1,
        navText: ["<i class='icon-carousel-left'><i class='icon-main-left'></i></i>", "<i class='icon-carousel-right'><i class='icon-main-right'></i></i>"],
        responsive: {
            0: {
                nav: false,
                dots: true,
                margin: 8,
            },
            1200: {
                nav: true,
                dots: false,
                margin: 20,
                // autoWidth: true,
            }
        }
    });
    //Fix for apple
    if ($(window).width() < 1200) {
        var options = {
            preventDefault: true
        };
        var reviewItem = document.querySelectorAll('.carousel');
        for (var i = 0; i < reviewItem.length; i++) {
            var hammertime = new Hammer(reviewItem[i], options);
            hammertime.on("swipeleft swiperight", function (ev) { });
        }
    }


    /**
     * Mobile menu and other controls
     */
    if ($(window).width() <= 1200) {
        //Open catalog
        var $btnOpen = $('.burger-btn'),
            $closeCatalog = $('.overlay_page, .header-menu .close-btn'),
            $showMenuEl = $('.header-menu');

        $btnOpen.on('click', function (e) {
            e.preventDefault();
            $showMenuEl.addClass('open');
            $('.overlay_page').fadeIn(200);

            if (window.innerWidth < 1092) {
                overlayOpen();
            } else {
                disable_scroll();
            }
        });

        $closeCatalog.on('click', function () {
            $showMenuEl.removeClass('open');
            if($('#beforeDeletingArticle').css('display') !== 'block') {
                $('.overlay_page').fadeOut(200);
            }

            if (window.innerWidth < 1092) {
                overlayClose();
            } else {
                enable_scroll();
            }
        });
    }

    $('.wrap_container').on('click', '.accordion-header', function(e) {
        e.preventDefault();

        if($(this).hasClass('open')) {
            $(this).next('.accordion-body').slideUp(200);
            $(this).removeClass('open');
            $(this).closest('.accordion-wrap').find('.accordion-header.open').next('.accordion-body').stop().slideUp(200);
            $(this).closest('.accordion-wrap').find('.accordion-header.open').removeClass('open');
        } else {
            $(this).closest('.accordion-wrap').find('.accordion-header.open').next('.accordion-body').stop().slideUp(200);
            $(this).closest('.accordion-wrap').find('.accordion-header.open').removeClass('open');
            $(this).next('.accordion-body').slideDown(200);
            $(this).addClass('open');
        }
    });

    $('.wrap_container').on('click', '.anchor-btn', function() {
        $("html, body").animate({ scrollTop: 0 }, "slow");
    });

    //feedback popup
    $('#feedback form').each(function () {
        $(this).validate({
            highlight: function (element) {
                $(element).addClass("error").removeClass("success");
            },
            unhighlight: function (element) {
                $(element).removeClass("error").addClass("success");
            },
            //Send form
            submitHandler: function (form) {
                console.log('Form send');
                $(form).find('[type=submit]').attr('disabled', true);
                var req = $.ajax({
                    method: 'post',
                    url: $(form).attr('action'),
                    data: $(form).serialize(),
                });
                req.done(function (resp) {
                    if (resp.success) {
                        console.log('{event:request_form}')
                        dataLayer.push({'event':'request_form'});
                        $(form).find('input').val('');
                        $(form).find('textarea').text('');
                        // $(form).closest('.wrap_popup').find('.close').trigger('click');
                        $(form).closest('.wrap_popup').find('.step1').hide();
                        $(form).closest('.wrap_popup').find('.step2').show();
                        $(form).find('[type=submit]').attr('disabled', true);
                    }
                })
                req.fail(function (error) {
                    var errors = $.parseJSON(error.responseText);
                    $.each(errors.errors, function (key, value) {
                        if (key == 'g-recaptcha-response') {
                            if ($(form).find('div.js-chaptcha label').length) {
                                $(form).find('div.js-chaptcha label').replace('<label id="' + key + '-error" class="error" for="' + key + '">' + value + '</label>');
                            } else {
                                $(form).find('div.js-chaptcha').after('<label id="' + key + '-error" class="error" for="' + key + '">' + value + '</label>');
                            }
                        }
                        $(form).find('input[name=' + key + ']').addClass('error');
                        $(form).find('input[name=' + key + ']').after('<label id="' + key + '-error" class="error" for="' + key + '">' + value + '</label>');
                    });
                    $(form).find('[type=submit]').attr('disabled', false);
                });
            }
        });
    });

    $(window).on('scroll', function() {
        if($(window).scrollTop() > $(window).height()) {
            $('.anchor-btn').fadeIn(200).css('display', 'flex');
        } else {
            $('.anchor-btn').fadeOut(200);
        }
    });

    var $root = $('html, body');
    $('.main-page + footer.light-blue-bg a[href*="#"]').click(function(e) {
        e.preventDefault();
        var href = $(this).attr('href');
        console.log(href)
        $root.animate({
            scrollTop: $(href.substring(1)).offset().top
        }, 500, function () {
            window.location.hash = href.substring(1);
        });

        return false;
    });

    //footer mobile
    $('.footer-col-header').on('click', function () {
      if ($(window).width() < 768) {
          if ($(this).hasClass('open')) {
              $(this).removeClass('open').next('ul').slideUp(200);
          } else {
              $(this).closest('footer').find('.open').removeClass('open').next('ul').slideUp(200);
              $(this).addClass('open').next('ul').slideDown(200);
          }
      }
    });

    $(document).on('click', '.cookie-accept-js', function (e) {
      e.preventDefault();
      var url = $(this).attr('data-url');
      $.post(url, {
        agree: true,
        '_token': CSRF_TOKEN
      }).done(function (data) {
        $('.cookie-info').fadeOut(200);
      });
    });

    // datalayer
    $('.social-link').on('click', function (e) {
        console.log('{event: social_click}');
        dataLayer.push({'event':'social_click'});
    })
});
